import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Button } from 'components/Button';

type GridButtonType = {
  isActive: boolean;
};

const Wrapper = styled.div`
  display: flex;
  align-items: center;

  margin-top: 1.5rem;
`;

const Container = styled.div`
  display: flex;
`;

const GridButton = styled(Button)<GridButtonType>`
  margin: 0 0.5rem;

  color: ${({ isActive }) => (isActive ? pickColor('black') : pickColor('red'))};
`;

export { Wrapper, Container, GridButton };
